import React, { Component } from 'react';
import { storage, db } from '../../ThirdPartyIntegration/firebaseClient';
import { config } from '../../config';
import { browserHistory } from 'react-router';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import 'whatwg-fetch';
import queryString from 'query-string';


class Profile extends Component {
    constructor() {
        super();

        let userJsonString = window.localStorage.getItem(config.localstorage.userKey);
        let user = JSON.parse(userJsonString);

        this.state = {
            isUploading: false,
            uploadProgress: 0,
            user: user
        };

        this.imageSelected = this.imageSelected.bind(this);
    }

    imageSelected(e) {
        let files = e.target.files;

        if (files.length < 1) {
            console.log('no file selected');
            return;
        }

        // let's upload it.
        let file = files[0];
        var metadata = {
            contentType: file.type
        };

        // TODO: DRY this duplicated upload code.
        // get the user's uid
        let user = this.state.user;

        // Upload file and metadata to the object 'images/mountains.jpg'
        var uploadTask = storage.ref().child(`images/${user.uid}/${file.name}`).put(file, metadata);

        var c = this;

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on('state_changed',
            function (snapshot) {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                c.setState({
                    isUploading: true,
                    uploadProgress: progress
                });
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                    case 'paused':
                        console.log('Upload is paused');
                        break;
                    case 'running':
                        console.log('Upload is running');
                        break;
                    default:
                        console.log(snapshot.state);
                }
            }, function (error) {

                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        console.log('access denied');
                        break;

                    case 'storage/canceled':
                        // User canceled the upload
                        console.log('upload cancelled');
                        break;
                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        console.log('unknown error');
                        break;
                    default:
                        console.log(error);
                }
            }, function () {
                // Upload completed successfully, now we can get the download URL
                // var downloadURL = uploadTask.snapshot.downloadURL;

                fetch('https://us-central1-nda-pwa.cloudfunctions.net/processProfileImage',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                        },
                        body: queryString.stringify({
                            "filePath": uploadTask.snapshot.ref.fullPath,
                            "bucket": uploadTask.snapshot.ref.bucket
                        })
                    }).then((response) => {
                        return response.json();
                    }).then((json) => {
                        console.log(json);
                        user.picture = json.processedImage;
                        console.log(json.processedImage);
                        db.ref().child(`users/${user.uid}/info`).update({"picture": json.processedImage}).then(() => {
                            c.setState({ isUploading: false });
                            if (c.props.whenDoneRedirectTo) {
                                browserHistory.push({pathname: c.props.whenDoneRedirectTo, state: { faces: json.faces }});
                            }
                        }).catch((e) => {
                            console.log(e);
                        });
                    });

            });
    }

    render() {
        const styles = {
            inputfile: {
                width: '0.1px',
                height: '0.1px',
                opacity: '0',
                overflow: 'hidden',
                position: 'absolute',
                zIndex: '-1'
            }
        }

        if (this.state.isUploading) {
            if (this.state.uploadProgress === 100) {
                return (
                    <p>Upload done. Blurring any faces. One sec...</p>
                )
            }
            return (
                <div>
                    Uploading image.
                    <CircularProgress mode="determinate" value={this.state.uploadProgress} />
                </div>
            )
        }

        return (
            <Button color="accent">
                <label htmlFor="newImageFile" style={styles.inputFileLabel}>
                    <input type="file"
                        name="newImageFile"
                        id="newImageFile"
                        accept="image/*"
                        style={styles.inputfile}
                        onChange={this.imageSelected} />
                    Change picture
                </label>
            </Button>
        )
    }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/Components/Elements/UploadPhotoButton.jsx